module.exports = function getResource(label, vars = []) {
    const resources = {
        sephoraCard: 'Carte Sephora',
        sephoraTempCard: 'Carte temporaire Sephora',
        sephoraVisaCard: 'Carte VISA Sephora',
        sephoraVisaTempCard: 'Carte temporaire Visa Sephora'
    };

    return resources[label];
};
